import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCloseStyle0 = cosmosIconCss;

const CosmosIconClose = /*@__PURE__*/ proxyCustomElement(class CosmosIconClose extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '71acd898fde5a049ec3ef6192d600ab4e42db6af', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6b781ba1e67a2eae5691e9ec62864173910a9320', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '56f221c9c2f57dc98d718cb01323469fea15c645', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m18.18 4.18-.35-.36a.51.51 0 0 0-.71 0L11 9.94 4.89 3.82a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7L10 11l-6.17 6.12a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 12.06l6.11 6.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7L12.07 11l6.11-6.12a.48.48 0 0 0 0-.7Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCloseStyle0; }
}, [1, "cosmos-icon-close", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-close"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-close":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconClose);
            }
            break;
    } });
}

export { CosmosIconClose as C, defineCustomElement as d };
